import { render } from "./SocialConnect.vue?vue&type=template&id=dadbdea6&scoped=true"
import script from "./SocialConnect.vue?vue&type=script&lang=js"
export * from "./SocialConnect.vue?vue&type=script&lang=js"

import "./SocialConnect.vue?vue&type=style&index=0&id=dadbdea6&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dadbdea6"]])

export default __exports__